import axios from './axios';
import { FileListResponse, FileListReq, FileSummaryResponse, FileTypes, FileTranscriptResponse, FoldersTotal } from '../types/file';

export const fileList = async (param: FileListReq): Promise<FileListResponse> => {
  const response = await axios.get(`/api2/ai/recording/list?${param?.sourceType ? `sourceType=${param.sourceType}&` : ''}pageNum=${param.pageNum}&pageSize=${param.pageSize || 30}&recycleStatus=${param.recycleStatus || 10}&folderId=${param?.folderId}`);
  return response.data.data;
};

export const sourceTypeList = async (): Promise<FileTypes> => {
  const response = await axios.get(`/api2/ai/recording/sourceTypeList`);
  return response.data.data;
};

export const folderList = async (): Promise<FoldersTotal> => {
  const response = await axios.get(`/api2/ai/folder/list`);
  return response.data.data;
};

// 总结详情
export const summaryDetail = async (id: number): Promise<FileSummaryResponse> => {
  const response = await axios.get(`/api2/v2/ai/transcript/summary?recordingId=${id}`);
  return response.data.data;
};

// 转写详情
export const transcriptDetail = async (id: number): Promise<FileTranscriptResponse> => {
  const response = await axios.get(`/api2/v2/ai/transcript/detail?recordingId=${id}`);
  return response.data.data;
};

// 转写详情
export const generateShare = async (params: { recordingId: number }): Promise<FileTranscriptResponse> => {
  const response = await axios.post(`/api2/ai/recording/share`, params);
  return response.data.data;
};


// 删除文件
export const deleteFile = async (params: { recordingIds: number }): Promise<any> => {
  const response = await axios.post(`/api2/ai/recording/recycle/delete`, params);
  return response.data;
};

//  移动回收站
export const recycleMoveFile = async (params: { recordingIds: number }): Promise<any> => {
  const response = await axios.post(`/api2/ai/recording/recycle/move`, params);
  return response.data;
};
//  回收站恢复
export const restoreFile = async (params: { recordingIds: number }): Promise<any> => {
  const response = await axios.post(`/api2/ai/recording/recycle/restore`, params);
  return response.data;
};
//  移动文件到文件夹
export const moveFileToFolder = async (params: { recordingIds: number[], folderId: number | null }): Promise<any> => {
  const response = await axios.post(`/api2/ai/recording/move`, params);
  return response.data;
};


// 重命名文件
export const renameFile = async (recordingId: number, fileName: string): Promise<any> => {
  const response = await axios.post(`/api2/ai/recording/updateName`, {
    recordingId,
    fileName
  });
  return response.data;
};

// 重新转写
export const retranscribeFile = async (params: { recordingId: number }): Promise<any> => {
  const response = await axios.post(`/api2/v3/ai/transcript/retry`, params);
  // 检查业务错误码
  if (response.data.code === 37001) {
    const error: any = new Error(response.data.message || '余额不足');
    error.code = 37001;
    error.response = response;
    throw error;
  }
  return response.data.data;
};

// 转写
export const transcribeFile = async (params: {
  "recordingId": number,
  "recordingLanguage": string,
  "type": string
}): Promise<any> => {
  const response = await axios.post(`/api2/v3/ai/transcript/commit`, params);
  // 检查业务错误码
  if (response.data.code === 37001) {
    const error: any = new Error(response.data.message || '余额不足');
    error.code = 37001;
    error.response = response;
    throw error;
  }
  return response.data.data;
};

// 重新总结
export const resummarizeFile = async (params: { recordingId: number }): Promise<any> => {
  const response = await axios.post(`/api2/v2/ai/summary/retry`, params);
  return response.data.data;
};

// 创建文件夹
export const createFolder = async (folderName: string): Promise<any> => {
  const response = await axios.post(`/api2/ai/folder/create`, {
    folderName
  });
  return response.data;
};

// 更新文件夹名称
export const updateFolder = async (folderId: number, folderName: string): Promise<any> => {
  const response = await axios.post(`/api2/ai/folder/update`, {
    folderId,
    folderName
  });
  return response.data;
};

// 删除文件夹
export const deleteFolder = async (folderId: number): Promise<any> => {
  const response = await axios.post(`/api2/ai/folder/delete`, {
    folderId
  });
  return response.data;
};

// 导出转写
export const exportTranscript = async (recordingId: number, format: string): Promise<{fileUrl: string}> => {
  const response = await axios.get(`/api2/ai/recording/exportTranscript?recordingId=${recordingId}&format=${format}`);
  return response.data.data;
};

// 导出总结
export const exportSummaryApi = async (recordingId: number, format: string): Promise<{fileUrl: string}> => {
  const response = await axios.get(`/api2/ai/recording/exportSummary?recordingId=${recordingId}&format=${format}`);
  return response.data.data;
};

// 导出思维导图
export const exportMindmap = async (recordingId: number, format: string): Promise<{fileUrl: string}> => {
  const response = await axios.get(`/api2/ai/recording/exportMindmap?recordingId=${recordingId}&format=${format}`);
  return response.data.data;
};

// 更新总结内容（标题和/或 Markdown）
export const updateSummary = async (params: {
  recordingId: number;
  title?: string;
  markdown?: string;
}): Promise<boolean> => {
  const response = await axios.post(`/api2/ai/recording/updateSummary`, params);
  return response.data.data === true;
};